module.exports = __webpack_public_path__ + "media/images/flags/16/Wallis-And-Futuna-ab1a25ceb8f5596fe32043416610ed7c.png";